import { CustomCheckboxInput, QuestionCard, SimpleText, YStack } from '@my/ui'
import { Control, useWatch } from 'react-hook-form'

import { DropdownField, InputField } from '../helpers/Helper'
import images from '../../../assets/images'
import { April2026UpdatedOptions, financialAdviceOptions } from '../data'

interface BehavioralAndPsychologicalFactorsProps {
  control: Control<any>
}

export const BehavioralAndPsychologicalFactors: React.FC<
  BehavioralAndPsychologicalFactorsProps
> = ({ control }) => {

  const adviceMethods = useWatch({ name: "Risk & Investment - Receive Financial Advice"});
  return (
    <>
      <YStack width={'100%'} pl={0}>
        <YStack
          borderWidth={1}
          borderRadius={10}
          borderColor={'rgba(133, 193, 157, 0.17)'}
          paddingVertical={20}
          paddingHorizontal={15}
          bg={'#F9F9F9'}
        >
          <SimpleText fontSize={16} fontWeight={'600'}>
            We are here to support and guide you through your financial journey. We are here to help
            you, not to judge you.
          </SimpleText>
        </YStack>
      </YStack>
      <QuestionCard questionGroupTitle="How do you feel about your current financial situation?">
        <InputField
          control={control}
          name="Behavioral And Psychological Factors - Financial Situation"
          placeholder="Please describe."
          label=""
          height={90}
          multiline
        />
      </QuestionCard>
      <QuestionCard questionGroupTitle="What are your biggest financial fears or concerns?">
        <InputField
          control={control}
          name="Behavioral And Psychological Factors - Financial Concerns"
          placeholder="Please describe."
          label=""
          height={90}
          multiline
        />
      </QuestionCard>
      <QuestionCard questionGroupTitle="How do you make financial decisions (impulse, research, advice from professionals)?">
        <InputField
          control={control}
          name="Behavioral And Psychological Factors - Financial Decisions"
          placeholder="Please describe."
          label=""
          height={90}
          multiline
        />
      </QuestionCard>
      <QuestionCard questionGroupTitle="How close do you feel to financial decisions?">
        <InputField
          control={control}
          name="Behavioral And Psychological Factors - Close to Financial Decisions"
          placeholder="Please describe."
          label=""
          height={90}
          multiline
        />
      </QuestionCard>
      <QuestionCard questionGroupTitle="How do you prefer to receive financial advice and information?">
        <CustomCheckboxInput
          options={financialAdviceOptions}
          control={control}
          name="Risk & Investment - Receive Financial Advice"
          multiple
        />
        {adviceMethods?.includes('Other (Please specify)') && <InputField
          control={control}
          name="Risk & Investment - Receive Financial Advice - Other"
          //placeholder=""
          label="If 'Other', please describe:"
          height={90}
          multiline
        />}
      </QuestionCard>
      <QuestionCard questionGroupTitle="Have you experienced any major life events in the past 12 months? (Select all that apply)">
        <CustomCheckboxInput
          control={control}
          name="Behavioral And Psychological Factors - Major Life events in Past 12 months"
          options={April2026UpdatedOptions['Behavioral Factors'].pastLifeEvents}
          multiple
        />
      </QuestionCard>
      <QuestionCard questionGroupTitle="When you receive unexpected money (bonus, tax refund, gift), what do you typically do first?">
        <DropdownField
          control={control}
          name="Behavioral And Psychological Factors - Unexpected Money Decision Making"
          items={April2026UpdatedOptions['Behavioral Factors'].unexpectedMoneyBehavior}
          native
        />
      </QuestionCard>
    </>
  )
}
